import { render } from "./DangerButton.vue?vue&type=template&id=26bc5db2"
import script from "./DangerButton.vue?vue&type=script&lang=js"
export * from "./DangerButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__